import "./pageNotFound.scss";

const PageNotFound = () => {
  return (
    <div className="containerPageNotFound">
      <h3>Page Not Found 404!</h3>
    </div>
  );
};

export default PageNotFound;
